import axios from 'axios';
import { getToken, rememberReturnTo, emitSessionExpired } from './session';

// El propio login puede responder 401/403 con credenciales invalidas: ahi no
// hay sesion que expirar, el mensaje de error lo muestra el formulario.
const AUTH_ENDPOINT = /\/user\/sign_in/;

const $axios = axios.create({
  baseURL: process.env.RAZZLE_API_URL,
});

$axios.interceptors.request.use(
  (config) => {
    const c = { ...config };
    // Legacy paths starting with /api/ were rewritten by the old Koa proxy that
    // stripped /api before forwarding. We replicate that here so call sites stay
    // unchanged across the codebase.
    if (typeof c.url === 'string' && c.url.startsWith('/api/')) {
      c.url = c.url.replace(/^\/api/, '');
    }
    const token = getToken();
    if (token) {
      c.headers = { ...c.headers, Authorization: `Bearer ${token}` };
    }
    return c;
  },
  error => Promise.reject(error),
);

$axios.interceptors.response.use(
  response => response,
  (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }
    const status = error.response && error.response.status;
    const url = (error.config && error.config.url) || '';
    const isExpired = (status === 401 || status === 403) && !AUTH_ENDPOINT.test(url);
    if (isExpired) {
      rememberReturnTo();
      emitSessionExpired();
    }
    return Promise.reject(error);
  },
);

export default $axios;
